module.exports = __webpack_public_path__ + "static/img/4.c921543.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R507/4.jpg
// module id = lnly
// module chunks = 1